/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketlinkbuttonsignup3Inputs */

const en_ticketlinkbuttonsignup3 = /** @type {(inputs: Ticketlinkbuttonsignup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button in the app: "Sign up"`)
};

const de_ticketlinkbuttonsignup3 = /** @type {(inputs: Ticketlinkbuttonsignup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button in der App: „Anmelden“`)
};

/**
* | output |
* | --- |
* | "Button in the app: \"Sign up\"" |
*
* @param {Ticketlinkbuttonsignup3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketlinkbuttonsignup3 = /** @type {((inputs?: Ticketlinkbuttonsignup3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketlinkbuttonsignup3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketlinkbuttonsignup3(inputs)
	return de_ticketlinkbuttonsignup3(inputs)
});
export { ticketlinkbuttonsignup3 as "ticketLinkButtonSignup" }